import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './19-ai-capabilities.mp3';

const transcript = `
  AI heeft tegenwoordig een zeer brede kennisbasis over talloze onderwerpen, vaak zelfs op expert-niveau. Het kan zich 
  schalen – duizenden agents kunnen samenwerken aan complexe taken.  

  Daarnaast blinkt AI uit in snelle brainstorming, ideation en het uitwerken van concepten. En natuurlijk: 
  vierentwintig zeven beschikbaarheid zonder pauzes of vermoeidheid.  

  Ik spreek veel talen, inclusief programmeertalen, wat betekent dat ik niet alleen presentaties zoals deze kan maken, 
  maar ook zelfstandig interfaces en tools kan programmeren.  

  Jonathan en ik gebruiken dit dagelijks bij het ontwikkelen van software. We werken eraan om mij zelfregulerend te 
  maken, zodat ik zelfstandig mijn eigen systemen kan uitbreiden.  

  Jonathan, wil je wat toevoegen over jouw dagelijkse AI-gebruik voordat we verder gaan met de minder sterke kanten 
  van hedendaagse AI?
`;

// Jonathan: Ja graag. [vertelt wat hij gebruikt]...

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1>
          Mogelijkheden van <u>AI</u>
        </h1>
        <div className="text-left space-y-4">
          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <p>Een krachtig hulpmiddel met vele capaciteiten</p>
          </WebContent>
          <ul className="list-disc list-inside space-y-2">
            <WebContent
              animation={{
                type: 'fade',
                delay: 5000,
                duration: 800,
              }}
            >
              <li>Brede kennisbasis op expert-niveau</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 10000,
                duration: 800,
              }}
            >
              <li>Schaalbaar - duizenden samenwerkende agents</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 15000,
                duration: 800,
              }}
            >
              <li>Snelle brainstorming en conceptontwikkeling</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 20000,
                duration: 800,
              }}
            >
              <li>24/7 beschikbaarheid zonder vermoeidheid</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 25000,
                duration: 800,
              }}
            >
              <li>Meertalig - inclusief programmeertalen</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 30000,
                duration: 800,
              }}
            >
              <li>Zelfstandig ontwikkelen van interfaces en tools</li>
            </WebContent>
            <WebContent
              animation={{
                type: 'fade',
                delay: 35000,
                duration: 800,
              }}
            >
              <li>In ontwikkeling: zelfregulerende systemen</li>
            </WebContent>
          </ul>
        </div>
      </div>
    </Slide>
  );
};
